import { caseGroupScopeIds, caseGroupScopes, } from '@debbie/common/dist/properties/index.js';
import { useCaseGroups } from '@debbie/cortex/dist/case-groups/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import Select from '../Select.js';
/**
 * Picks the case groups a property type is scoped to. Selecting none leaves the
 * type tenant-wide, which is what the hint spells out.
 */
const PropertyScopeSelect = (props) => {
    const lang = useSelector((s) => s.lang);
    // Memoized so `Select` keeps its own `selected` memo across renders.
    const selectedCaseGroupIds = React.useMemo(() => caseGroupScopeIds(props.scopes), [props.scopes]);
    const caseGroupsLoadable = useCaseGroups();
    const caseGroups = h.hasData(caseGroupsLoadable)
        ? caseGroupsLoadable.data
        : [];
    return (React.createElement(React.Fragment, null,
        React.createElement(Select, { multi: true, label: lang.caseGroups.caseGroups, searchPlaceholder: lang.misc.search, options: caseGroups.map((caseGroup) => ({
                value: caseGroup.id,
                label: caseGroup.label,
            })), selected: selectedCaseGroupIds, onChange: (caseGroupIds) => props.onChange(caseGroupScopes(caseGroupIds)) }),
        props.scopes.length === 0 && (React.createElement(ScopeHint, null, lang.properties.addedToAllCases))));
};
export default PropertyScopeSelect;
/* Pulled up to sit right under the Select, which carries its own bottom margin. */
const ScopeHint = styled.div `
  margin: -14px 0 ${THEME.GRID_SPACING}px;
  font-size: 0.85em;
  color: ${THEME.TEXT_MUTED};
`;
//# sourceMappingURL=PropertyScopeSelect.js.map